import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from '../../service/common.service';
import { ApiService } from '../../service/api.service';
import { DataServiceService } from '../../service/data-share.service';
import { DatePipe, Location } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-product-cart-view',
  templateUrl: './product-cart-view.component.html',
  styleUrls: ['./product-cart-view.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule]
})
export class ProductCartViewComponent implements OnInit, OnDestroy {
  subscription!: Subscription;
  carts: any = [];
  qty: any = 1;
  userData: any = {};
  totalItems: any = 0;
  totalAmounts: any = 0;
  discountAmounts: any = 0;
  deliverCharges: any = 0;
  plateformFee: any = 0;
  grandTotal: any = 0;
  isLoading: boolean = true;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _service: CommonService,
    private api: ApiService,
    private dataShare: DataServiceService,
    public _location: Location,
    private ngxService: NgxUiLoaderService
  ) {
    if (localStorage.getItem('userData')) {
      const u: any = localStorage.getItem('userData');
      this.userData = JSON.parse(u);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this._location.back();
    }
  }

  ngOnInit(): void {
    this.getAllCartData();
  }

  getAllCartData() {
    const body = {
      user_id: this.userData.id,
    };
    this.totalItems = 0;
    this.totalAmounts = 0;
    this.subscription = this.api
      .commonPost('product/get/addToCart', body)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.status && res.statusCode == 200) {
            res.response.forEach((ele: any) => {
              ele.url = this.api.imageUrl + ele.data[0].url;
              this.totalItems += ele.quantity;
              ele.amounts = (parseFloat(ele.productPrice) * ele.quantity).toFixed(2);
              this.totalAmounts += parseFloat(ele.amounts);
            });
            this.carts = res.response;
            this.calculateTotal();
          } else {
            this.carts = [];
            this.router.navigate(['/']);
          }
        },
        (error) => {
          this.isLoading = false;
          console.log(error);
        }
      );
  }

  calculateTotal() {
    this.grandTotal = this.totalAmounts - this.discountAmounts + this.deliverCharges + this.plateformFee;
  }

  addQty(data: any, i: any) {
    let qty = data.quantity + 1;
    this.carts[i].quantity = qty;
    this.addQtyMore(qty, data?.product_id);
  }

  subtractQty(data: any, i: any) {
    let qty = data.quantity - 1;
    this.carts[i].quantity = qty;
    if (qty == 0) {
      this.removeCartPro(data.cart_id, data.product_id);
    } else {
      this.addQtyMore(qty, data?.product_id);
    }
  }
  addQtyMore(quantity: any, product_id: any) {
    const body = {
      user_id: this.userData.id,
      quantity: quantity,
      product_id: product_id,
    };
    this.subscription = this.api
      .commonPost('create/product/addToCart', body)
      .subscribe(
        (res: any) => {
          if (res.status && res.statusCode == 200) {
            this.getAllCartData();
          } else {
          }
        },
        (error) => console.log(error)
      );
  }
  removeCartPro(cart_id: any, product_id: any) {
    const body = {
      user_id: this.userData.id,
      cart_id: cart_id,
      product_id: product_id,
    };
    this.subscription = this.api
      .commonPost('create/product/remove/addToCart', body)
      .subscribe(
        (res: any) => {
          if (res.status && res.statusCode == 200) {
            this.getAllCartData();
            this.dataShare.passValue('');
          } else {
          }
        },
        (error) => console.log(error)
      );
  }

  gotoCheckOut() {
    this.router.navigate(['/check-out']);
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
